import * as React from 'react'
import * as css from './AltEnergyContent.module.css'
import HexPattern from 'components/common/HexPattern'
import HTag from 'components/common/HTag'
import SanityBlock from 'components/common/SanityBlock'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const AltEnergyContent = ({ s1heading, s1content, _rawSpecialties, s2heading, _rawS2Content, image }) => <>
  <section className="relative bg-suede-black text-white overflow-hidden">
    <HexPattern className={css.pattern} />

    <div className="padding">
      <div className="grid md:grid-cols-2 gap-16 items-center ctnr">
        <div className="richtext">
          <HTag className="h0" {...s1heading} />
          <p className="max-w-[450px]">{s1content}</p>
        </div>

        <SanityBlock className={css.txt} body={_rawSpecialties} />
      </div>
    </div>
  </section>

  <section className="bg-white">
    <div className="grid md:grid-cols-2 gap-8 items-center max-w-screen-xl mx-auto py-8 px-4">
      <div className="richtext">
        <HTag className="h1" {...s2heading} />
        <SanityBlock className="text-xl" body={_rawS2Content} />
      </div>

      <div>
        {!!image?.image && (
          <GatsbyImage
            className="multiply"
            image={getImage(image.image.asset)}
            objectFit="contain"
            alt={image.alt || ''}
          />
        )}
      </div>
    </div>
  </section>
</>

export default AltEnergyContent
